// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import WechatMpPay from '@/views/WechatMpPay.vue'
import WebPay from '@/views/WebPay.vue'
import VideoRemove from '@/views/VideoRemove.vue'
import RemoveWatermark from '@/views/RemoveWatermark.vue'
import AiImageRemove from '@/views/AiImageRemove.vue'
import RemoveBg from '@/views/RemoveBg.vue'
import Home from '@/views/Home.vue'
import CurrencyRecord from '@/views/CurrencyRecord.vue'
import CommonQuestion from '@/views/CommonQuestion.vue'
import TutorialPage from '@/views/TutorialPage.vue'
import ServiceStatement from '@/views/ServiceStatement.vue'
import ProfileCenter from '@/views/ProfileCenter.vue'

const scrollPositionMap = new Map()

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/wechat-mppay',
    name: 'WechatMpPay',
    component: WechatMpPay
  },
  {
    path: '/web-pay',
    name: 'WebPay',
    component: WebPay
  },
  {
    path: '/video-remove',
    name: 'VideoRemove',
    component: VideoRemove
  },
  {
    path: '/remove-watermark',
    name: 'RemoveWatermark',
    component: RemoveWatermark
  },
  {
    path: '/ai-image-remove',
    name: 'AiImageRemove',
    component: AiImageRemove
  },
  {
    path: '/remove-bg',
    name: 'RemoveBg',
    component: RemoveBg
  },
  {
    path: '/currency-record',
    name: 'CurrencyRecord',
    component: CurrencyRecord
  },
  {
    path: '/common-question',
    name: 'CommonQuestion',
    component: CommonQuestion
  },
  {
    path: '/tutorial',
    name: 'TutorialPage',
    component: TutorialPage
  },
  {
    path: '/service-statement',
    name: 'ServiceStatement',
    component: ServiceStatement
  },
  {
    path: '/profile',
    name: 'ProfileCenter',
    component: ProfileCenter
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    if (to.hash) {
      return {
        el: to.hash,
        top: 96,
        behavior: 'smooth'
      }
    }

    const savedRoutePosition = scrollPositionMap.get(to.fullPath)
    if (savedRoutePosition) {
      return savedRoutePosition
    }

    return { top: 0, left: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (from.fullPath) {
    scrollPositionMap.set(from.fullPath, {
      left: window.scrollX || 0,
      top: window.scrollY || 0
    })
  }
  next()
})

export default router
